import type { PatientStatus, UUID } from "@/core/types";
import { providerRequestsTyped } from "@/api/(requests)/providerTyped";
import type { UpdatePatientStatusResponse } from "@/api/(requests)/providerTyped";

export type UpdatePatientStatusVariables = {
  patientId: UUID;
  providerName?: string;
  reason?: string;
  status: PatientStatus;
};

export async function updatePatientStatus({
  patientId,
  providerName,
  reason,
  status,
}: UpdatePatientStatusVariables): Promise<UpdatePatientStatusResponse> {
  return providerRequestsTyped.update_patient_status({
    context: { showLoader: false },
    data: { providerName, reason, status, username: patientId },
    patientId,
  });
}
